import {
  API_BASE_PATH,
  APP_NAME,
  WEBSITE_BASE_PATH,
  WEBSITE_DOMAIN,
} from '@/constants/auth';
import Passwordless from 'supertokens-auth-react/recipe/passwordless';
import { API_HOST } from '@/constants/api-routes';
import SessionReact from 'supertokens-auth-react/recipe/session';

export const superTokensConfig = () => {
  return {
    appInfo: {
      appName: APP_NAME,
      apiDomain: API_HOST,
      websiteDomain: WEBSITE_DOMAIN,
      apiBasePath: API_BASE_PATH,
      websiteBasePath: WEBSITE_BASE_PATH,
    },

    termsOfServiceLink: 'https://www.cogknit.io/terms',
    privacyPolicyLink: 'https://www.cogknit.io/privacy',

    useShadowDom: false,

    /**
     * GLOBAL SuperTokens styles
     */
    style: `
  /* Base container */
  [data-supertokens~="container"] {
    background: transparent;
    box-shadow: none;
    padding: 0;
    font-family: inherit;
  }

  /* Remove branding & extras */
  [data-supertokens~="superTokensBranding"],
  [data-supertokens~="withBackButton"],
  [data-supertokens~="divider"] {
    display: none !important;
  }

  /* FIX: titles like "Enter OTP" / "Sign in" */
  [data-supertokens~="headerTitle"],
  [data-supertokens~="headerSubtitle"],
  [data-supertokens~="label"],
  [data-supertokens~="generalError"],
  [data-supertokens~="secondaryText"],
  [data-supertokens~="infoText"] {
    color: hsl(var(--foreground)) !important;
  }

  /* Subtitle / helper text slightly muted */
  [data-supertokens~="headerSubtitle"],
  [data-supertokens~="secondaryText"],
  [data-supertokens~="infoText"] {
    color: hsl(var(--muted-foreground)) !important;
  }

  /*  Extra: in dark mode boost subtitle contrast */
  .dark [data-supertokens~="headerSubtitle"],
  .dark [data-supertokens~="secondaryText"],
  .dark [data-supertokens~="infoText"] {
    color: hsl(var(--foreground) / 0.85) !important;
  }

  /* Inputs */
  [data-supertokens~="input"],
  [data-supertokens~="otpInput"] {
    border-radius: 0.5rem;
    border: 1px solid hsl(var(--border));
    background: hsl(var(--background));
    color: hsl(var(--foreground));
  }

  [data-supertokens~="input"]::placeholder {
    color: hsl(var(--muted-foreground));
  }

  [data-supertokens~="input"]:focus,
  [data-supertokens~="otpInput"]:focus {
    outline: none;
    border-color: hsl(var(--primary));
    box-shadow: 0 0 0 2px hsl(var(--primary) / 0.25);
  }
`,

    recipeList: [
      Passwordless.init({
        contactMethod: 'EMAIL',

        /**
         * Passwordless-specific theming
         */
        style: `
          /* Primary palette (used internally by SuperTokens) */
          [data-supertokens~="container"] {
            --palette-primary: var(--primary);
          }

          /* Button */
          [data-supertokens~="button"] {
            border-radius: 0.5rem;
            background: hsl(var(--primary));
            color: hsl(var(--primary-foreground));
            font-weight: 600;
            border: none;
            margin: 0 auto;
            transition: background 0.2s ease, transform 0.1s ease;
          }

    
          [data-supertokens~="button"]:active {
            transform: translateY(1px);
          }

          /* Disabled */
          [data-supertokens~="button"][disabled] {
            opacity: 0.6;
            cursor: not-allowed;
          }
/* =========================
   SuperTokens General Error
   ========================= */

/* Base error container */
[data-supertokens~="generalError"] {
  margin-top: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;

  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.4;

  border: 1px solid hsl(var(--destructive) / 0.4);
  background: hsl(var(--destructive) / 0.1);
  color: hsl(var(--destructive));

  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* Optional: add subtle emphasis */
[data-supertokens~="generalError"]::before {
  content: "⚠";
  font-size: 1rem;
  line-height: 1;
}

/* -------------------------
   Dark mode contrast boost
   ------------------------- */
.dark [data-supertokens~="generalError"] {
  background: hsl(var(--destructive) / 0.18);
  border-color: hsl(var(--destructive) / 0.6);
  color: hsl(var(--destructive));
}

          /* OTP input boxes */
          [data-supertokens~="otpInput"] {
            border-radius: 0.5rem;
            border: 1px solid hsl(var(--border));
            background: hsl(var(--background));
            color: hsl(var(--foreground));
          }

          [data-supertokens~="otpInput"]:focus {
            border-color: hsl(var(--primary));
            box-shadow: 0 0 0 2px hsl(var(--primary) / 0.25);
          }
        `,
      }),

      SessionReact.init(),
    ],
  };
};
